<template>
    <PopupRouterViewDetail label="Stock Opname Result Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Stock Opname Result" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="STO Result Number" :model="model.stoResultNumber" />
						<app-input-combobox-autocomplete :options="stockOpnames" optionsLabel="StockOpnameLabelCombo" optionsKey="id" label-cols-lg="12" label="Stock Opname" id="fieldset-stock-opname" size="sm" :model.sync="model.stockOpnameId"   :selected="model.stockOpname != null ? model.stockOpname.stockOpnameLabelCombo : ''" @input="getStockOpnames" @change="updateData" :isEditable="false" :isUpdatable="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedStockOpname" />
						<app-input-fileupload id="fieldset-file-upload" label-cols-lg="12"  label="File Upload" size="sm" :model.sync="fileUpload"  :currentModel="model.fileUpload" @change="updateData" :isEditable="false" :isUpdatable="false"/>
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Area" id="fieldset-area" size="sm" :model.sync="model.areaId"   :selected="model.area != null ? model.area.code : ''" @input="getAreas" @change="updateData" :isEditable="false" :isUpdatable="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedArea" />
						<app-input-combobox-autocomplete :options="stockOpnamePlans" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Stock Opname Plan" id="fieldset-stock-opname-plan" size="sm" :model.sync="model.stockOpnamePlanId"   :selected="model.stockOpnamePlan != null ? model.stockOpnamePlan.name : ''" @input="getStockOpnamePlans" @change="updateData" :isEditable="false" :isUpdatable="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedStockOpnamePlan" />
				</b-col>
            </b-row>
        </b-card>

        <b-card header="Summary Case Information" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<!-- <app-input-textbox id="fieldset-total-qty-system" label-cols-lg="12"  label="Case Qty System" label-for="input-total-qty-system" size="sm" :model.sync="model.totalQtySystem"  @change="updateData" :isEditable="false" :isUpdatable="false"/>
						<app-input-textbox id="fieldset-total-qty-actual" label-cols-lg="12"  label="Actual Qty" label-for="input-total-qty-actual" size="sm" :model.sync="model.totalQtyActual"  @change="updateData" :isEditable="false" :isUpdatable="false"/> -->
						<app-label label-cols-lg="12" size="sm" label="Case Qty System" :model="model.totalQtySystem!=null && model.totalQtySystem!=undefined ? model.totalQtySystem.toLocaleString():''" :sameSizeLabelValue="false" />
						<app-label label-cols-lg="12" size="sm" label="Actual Qty" :model="model.totalQtyActual!=null && model.totalQtyActual!=undefined ? model.totalQtyActual.toLocaleString():''" :sameSizeLabelValue="false" />
					</b-col>
					<b-col cols="12" lg="6">
						<!-- <app-input-textbox id="fieldset-total-difference-qty" label-cols-lg="12"  label="Difference" label-for="input-total-difference-qty" size="sm" :model.sync="model.totalDifferenceQty"  @change="updateData" :isEditable="false" :isUpdatable="false"/>
						<app-input-textbox id="fieldset-total-differencet-percentage-qty" label-cols-lg="12"  label="Differencet Percentage" label-for="input-total-differencet-percentage-qty" size="sm" :model.sync="model.totalDifferencetPercentageQty"  @change="updateData" :isEditable="false" :isUpdatable="false"/> -->
						<app-label label-cols-lg="12" size="sm" label="Difference" :model="model.totalDifferenceQty!=null && model.totalDifferenceQty!=undefined ? model.totalDifferenceQty.toLocaleString():''" :sameSizeLabelValue="false" />
						<app-label label-cols-lg="12" size="sm" label="Difference Percentage" :model="(model.totalDifferencetPercentageQty!=null && model.totalDifferencetPercentageQty!=undefined ? model.totalDifferencetPercentageQty.toLocaleString():'') + ' %'" :sameSizeLabelValue="false" />
				</b-col>
            </b-row>
        </b-card>

        <b-card header="Total Price Comparison" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<!-- <app-input-textbox id="fieldset-total-price-qty-system" label-cols-lg="12"  label="Total Price Qty System" label-for="input-total-price-qty-system" size="sm" :model.sync="model.totalPriceQtySystem"  @change="updateData" :isEditable="false" :isUpdatable="false"/>
						<app-input-textbox id="fieldset-total-price-qty-actual" label-cols-lg="12"  label="Total Price Qty Actual" label-for="input-total-price-qty-actual" size="sm" :model.sync="model.totalPriceQtyActual"  @change="updateData" :isEditable="false" :isUpdatable="false"/> -->
						<app-label label-cols-lg="12" size="sm" label="Total Price Qty System" :model="model.totalPriceQtySystem!=null && model.totalPriceQtySystem!=undefined ? model.totalPriceQtySystem.toLocaleString():''" :sameSizeLabelValue="false" />
						<app-label label-cols-lg="12" size="sm" label="Total Price Qty Actual" :model="model.totalPriceQtyActual!=null && model.totalPriceQtyActual!=undefined ? model.totalPriceQtyActual.toLocaleString():''" :sameSizeLabelValue="false" />
					</b-col>
					<b-col cols="12" lg="6">
						<!-- <app-input-textbox id="fieldset-total-difference-price" label-cols-lg="12"  label="Total Difference Price" label-for="input-total-difference-price" size="sm" :model.sync="model.totalDifferencePrice"  @change="updateData" :isEditable="false" :isUpdatable="false"/> -->
						<app-label label-cols-lg="12" size="sm" label="Total Difference Price" :model="model.totalDifferencePrice!=null && model.totalDifferencePrice!=undefined ? model.totalDifferencePrice.toLocaleString():''" :sameSizeLabelValue="false" />
				</b-col>
            </b-row>
        </b-card>

		<app-table-input-popup title="List Case" :bordered="true" :items="stockOpnameResultDetails" :fields="fieldsStockOpnameResultDetail" :busy="isDataLoading" :sort-by.sync="sortByStockOpnameResultDetail" :sort-desc.sync="sortDescStockOpnameResultDetail" small responsive
			@editButtonMethod="editRowDataStockOpnameResultDetail"
			@deleteButtonMethod="deleteRowDataStockOpnameResultDetail"
			@showPopupAddMethod="resetDataStockOpnameResultDetail()"
			@showPopupUploadMethod="showPopupUploadStockOpnameResultDetail()"
			@downloadMethod="downloadStockOpnameResultDetail()"
			@addFromClipboardMethod="addFromClipboardStockOpnameResultDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardStockOpnameResultDetail()"
			:showActionButton="false"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadStockOpnameResultDetail"
			class="custom-row-style"
			>
			<template #top-row v-if="isShowStockOpnameResultDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Control Card">
					<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'filter-stock-opname-detail-card'" label-cols-lg="12" label="Control Card" size="sm" :model.sync="filterStockOpnameResultDetail.controlCardId"  @change="getStockOpnameResultDetails" @input="getControlCards" :loading="isControlCardComboLoading" :nolabel="true" />
					<!-- <v-select append-to-body label="controlCardNumber" :options="controlCards"  :value="filterStockOpnameResultDetail.controlCardId" :reduce="item => item.id" v-model="filterStockOpnameResultDetail.controlCardId" @search="getControlCards" :filterable="true"></v-select> -->
				</b-th>
				<b-th stacked-heading="Part">
					<!-- <v-select append-to-body label="controlCardNumber" :options="parts"  :value="filterStockOpnameResultDetail.partId" :reduce="item => item.id" v-model="filterStockOpnameResultDetail.partId" @search="getControlCards" :filterable="true"></v-select> -->
				</b-th>
				<b-th stacked-heading="Qty System">
					<!-- <b-form-input id="input-qty-system-table" v-model="filterStockOpnameResultDetail.qtySystem" size="sm"></b-form-input> -->
				</b-th>
				<b-th stacked-heading="Total Price Qty System">
					<!-- <b-form-input id="input-total-price-qty-system-table" v-model="filterStockOpnameResultDetail.totalPriceQtySystem" size="sm"></b-form-input> -->
				</b-th>
				<b-th stacked-heading="Qty Actual">
					<!-- <b-form-input id="input-qty-actual-table" v-model="filterStockOpnameResultDetail.qtyActual" size="sm"></b-form-input> -->
				</b-th>
				<b-th stacked-heading="Total Price Qty Actual">
					<!-- <b-form-input id="input-total-price-qty-actual-table" v-model="filterStockOpnameResultDetail.totalPriceQtyActual" size="sm"></b-form-input> -->
				</b-th>
				<b-th stacked-heading="Total Difference Qty">
					<!-- <b-form-input id="input-total-difference-qty-table" v-model="filterStockOpnameResultDetail.totalDifferenceQty" size="sm"></b-form-input> -->
				</b-th>
				<b-th stacked-heading="Total Difference Price">
					<!-- <b-form-input id="input-total-difference-price-table" v-model="filterStockOpnameResultDetail.totalDifferencePrice" size="sm"></b-form-input> -->
				</b-th>
				<b-th stacked-heading="Difference Percentage">
					<!-- <b-form-input id="input-differenct-percentage-table" v-model="filterStockOpnameResultDetail.differenctPercentage" size="sm"></b-form-input> -->
				</b-th>
				<b-th></b-th>
				<b-th stacked-heading="Scanned Date">
					<b-form-datepicker boundary="viewport" placeholder="" id="input-scanned-date-from-table" v-model="filterStockOpnameResultDetail.scannedDateFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button></b-form-datepicker>
					<b-form-datepicker boundary="viewport" placeholder="" id="input-scanned-date-to-table" v-model="filterStockOpnameResultDetail.scannedDateTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button></b-form-datepicker>
				</b-th>
				<b-th stacked-heading="Scanned By">
					<!-- <v-select append-to-body label="firstName" :options="userInfos"  :value="filterStockOpnameResultDetail.scannedById" :reduce="item => item.id" v-model="filterStockOpnameResultDetail.scannedById" @search="getUserInfos" :filterable="true"></v-select> -->
				</b-th>
				<b-th stacked-heading="Stock Opname Detail">
					<!-- <v-select append-to-body label="controlCard" :options="stockOpnameDetails"  :value="filterStockOpnameResultDetail.stockOpnameDetailId" :reduce="item => item.id" v-model="filterStockOpnameResultDetail.stockOpnameDetailId" @search="getStockOpnameDetails" :filterable="true"></v-select> -->
				</b-th>
				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( stockOpnameResultDetailPageSize * (currentStockOpnameResultDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:head(frontActions)>
				<b-button @click="isShowStockOpnameResultDetailFilter = !isShowStockOpnameResultDetailFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
			</template>
			<template v-slot:cell(controlCard)="row">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-stock-opname-result-detail-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId"  @change="saveInputStockOpnameResultDetail(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading" :isEditable="false" :isUpdatable="false" :nolabel="true" />
			</template>
			
			<template v-slot:cell(partNumber)="row">
				{{ row.item.controlCard!=null && row.item.controlCard!=undefined && row.item.controlCard.part!=null && row.item.controlCard.part!=undefined ? row.item.controlCard.part.partNumber :"" }}
			</template>
			
			<template v-slot:cell(partName)="row">
				{{ row.item.controlCard!=null && row.item.controlCard!=undefined && row.item.controlCard.part!=null && row.item.controlCard.part!=undefined ? row.item.controlCard.part.partName :"" }}
			</template>
			<template v-slot:cell(qtySystem)="row">
				{{ row.item.qtySystem!=null && row.item.qtySystem!=undefined ? row.item.qtySystem.toLocaleString():"" }}
			</template>
			<template v-slot:cell(totalPriceQtySystem)="row">
				{{ row.item.totalPriceQtySystem!=null && row.item.totalPriceQtySystem!=undefined ? row.item.totalPriceQtySystem.toLocaleString():"" }}
			</template>
			<template v-slot:cell(qtyActual)="row">
				{{ row.item.qtyActual!=null && row.item.qtyActual!=undefined ? row.item.qtyActual.toLocaleString():"" }}
				<!-- <app-input-textbox :id="'input-stock-opname-result-detail-qty-actual-' + row.index" label-cols-lg="12" label="Qty Actual" size="sm" :model.sync="row.item.qtyActual"   @change="RecalculateAndSave(row.item)" :isUpdatable="true" :isEditable="true" :nolabel="true"  /> -->
			</template>
			<template v-slot:cell(totalPriceQtyActual)="row">
				{{ row.item.totalPriceQtyActual!=null && row.item.totalPriceQtyActual!=undefined ? row.item.totalPriceQtyActual.toLocaleString():"" }}
			</template>
			<template v-slot:cell(totalDifferenceQty)="row">
				{{ row.item.totalDifferenceQty!=null && row.item.totalDifferenceQty!=undefined ? row.item.totalDifferenceQty.toLocaleString():"" }}
			</template>
			<template v-slot:cell(totalDifferencePrice)="row">
				{{ row.item.totalDifferencePrice!=null && row.item.totalDifferencePrice!=undefined ? row.item.totalDifferencePrice.toLocaleString():"" }}
			</template>
			<template v-slot:cell(differenctPercentage)="row">
				{{ isNaN(row.item.differenctPercentage)? "0" : (row.item.differenctPercentage!=undefined && row.item.differenctPercentage!=null ? row.item.differenctPercentage.toLocaleString():'') }} <b-icon-percent></b-icon-percent>
			</template>
			<template v-slot:cell(scannedDate)="row">
				<app-input-datepicker  :id="'input-stock-opname-result-detail-scanned-date-' + row.index" label-cols-lg="12" label="Scanned Date" size="sm" :model.sync="row.item.scannedDate"   @change="saveInputStockOpnameResultDetail(row.item)" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" :isEditable="false" :isUpdatable="false" :nolabel="true"  />
			</template>
			<template v-slot:cell(scannedBy)="row">
				<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" :id="'input-stock-opname-result-detail-scanned-by-' + row.index" label-cols-lg="12" label="Scanned By" size="sm" :model.sync="row.item.scannedById"  @change="saveInputStockOpnameResultDetail(row.item)" :selected="row.item.scannedBy != null ? row.item.scannedBy.firstName : ''"  @input="getUserInfos" :loading="isUserInfoComboLoading" :isEditable="false" :isUpdatable="false" :nolabel="true" />
			</template>
			<template v-slot:cell(stockOpnameDetail)="row">
				<app-input-combobox-autocomplete :options="stockOpnameDetails" optionsLabel="controlCard" optionsKey="id" :id="'input-stock-opname-result-detail-stock-opname-detail-' + row.index" label-cols-lg="12" label="Stock Opname Detail" size="sm" :model.sync="row.item.stockOpnameDetailId"  @change="saveInputStockOpnameResultDetail(row.item)" :selected="row.item.stockOpnameDetail != null ? row.item.stockOpnameDetail.controlCard : ''"  @input="getStockOpnameDetails" :loading="isStockOpnameDetailComboLoading" :isEditable="false" :isUpdatable="false" :nolabel="true" />
			</template>
			<template v-slot:cell(remarks)="row">
									{{ (row.item.stockOpnameDetail != null) ? row.item.stockOpnameDetail.remarks : null}}
						<!-- <app-label label-cols-lg="12" size="sm" label="Remarks" :model="(row.item.stockOpnameDetail != null) ? row.item.stockOpnameDetail.remarks : null"  /> -->
			</template>

			<template v-slot:form-add-detail>
				<StockOpnameResultDetailInput 
					:openPopup="isShowPopupStockOpnameResultDetail"
					:modelId="stockOpnameResultDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataStockOpnameResultDetail"/>
			</template>
			<template v-slot:upload-detail>
				<StockOpnameResultDetailUpload
					:openPopup="isShowPopupUploadStockOpnameResultDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataStockOpnameResultDetail"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
					<app-input-textbox :id="'input-stock-opname-result-detail-qty-system-' + row.index" label-cols-lg="12" label="Qty System" size="sm" :model.sync="row.item.qtySystem"   @change="saveInputStockOpnameResultDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-stock-opname-result-detail-total-price-qty-system-' + row.index" label-cols-lg="12" label="Total Price Qty System" size="sm" :model.sync="row.item.totalPriceQtySystem"   @change="saveInputStockOpnameResultDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-stock-opname-result-detail-qty-actual-' + row.index" label-cols-lg="12" label="Qty Actual" size="sm" :model.sync="row.item.qtyActual"   @change="saveInputStockOpnameResultDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-stock-opname-result-detail-total-price-qty-actual-' + row.index" label-cols-lg="12" label="Total Price Qty Actual" size="sm" :model.sync="row.item.totalPriceQtyActual"   @change="saveInputStockOpnameResultDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-stock-opname-result-detail-total-difference-qty-' + row.index" label-cols-lg="12" label="Total Difference Qty" size="sm" :model.sync="row.item.totalDifferenceQty"   @change="saveInputStockOpnameResultDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-stock-opname-result-detail-total-difference-price-' + row.index" label-cols-lg="12" label="Total Difference Price" size="sm" :model.sync="row.item.totalDifferencePrice"   @change="saveInputStockOpnameResultDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-stock-opname-result-detail-differenct-percentage-' + row.index" label-cols-lg="12" label="Difference Percentage" size="sm" :model.sync="row.item.differenctPercentage"   @change="saveInputStockOpnameResultDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-datepicker  :id="'input-stock-opname-result-detail-scanned-date-' + row.index" label-cols-lg="12" label="Scanned Date" size="sm" :model.sync="row.item.scannedDate"   @change="saveInputStockOpnameResultDetail(row.item)" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" :isUpdatable="false" :isEditable="false"   />
					<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" :id="'input-stock-opname-result-detail-scanned-by-' + row.index" label-cols-lg="12" label="Scanned By" size="sm" :model.sync="row.item.scannedById"  @change="saveInputStockOpnameResultDetail(row.item)" :selected="row.item.scannedBy != null ? row.item.scannedBy.firstName : ''"  @input="getUserInfos" :loading="isUserInfoComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-combobox-autocomplete :options="stockOpnameDetails" optionsLabel="controlCard" optionsKey="id" :id="'input-stock-opname-result-detail-stock-opname-detail-' + row.index" label-cols-lg="12" label="Stock Opname Detail" size="sm" :model.sync="row.item.stockOpnameDetailId"  @change="saveInputStockOpnameResultDetail(row.item)" :selected="row.item.stockOpnameDetail != null ? row.item.stockOpnameDetail.controlCard : ''"  @input="getStockOpnameDetails" :loading="isStockOpnameDetailComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-label label-cols-lg="12" size="sm" label="Remarks" :model="(row.item.stockOpnameDetail != null) ? row.item.stockOpnameDetail.remarks : null"  />
				</b-card>
			</template>

			<template #table-paging>
				<b-row>
					<b-col cols="12" class="paging-container">
						<div>
							<b-row>
								<b-col cols="12" class="paging-item">
									<b-pagination class="btn-paging paging-page-size float-right"
										v-model="currentStockOpnameResultDetailPage"
										:total-rows="(stockOpnameResultDetailsPaging != null ? stockOpnameResultDetailsPaging.dataCount : 0)"
										:per-page="(stockOpnameResultDetailsPaging != null ? stockOpnameResultDetailsPaging.pageSize : 0)"
										aria-controls="table-input">
										<template #first-text>
											<b-icon-chevron-left />
										</template>
										<template #prev-text>
											Prev
										</template>
										<template #next-text>
											Next
										</template>
										<template #last-text>
											<b-icon-chevron-right />
										</template>
									</b-pagination>
									<span class="paging-page-size float-right">
										<b-form-select v-if="false" v-model="stockOpnameResultDetailPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
										<b-dropdown :text="stockOpnameResultDetailPageSize + ' per page'" class="m-md-2 btn-paging-size" size="sm">
											<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="stockOpnameResultDetailPageSize = item.value">
												{{ item.text }}
											</b-dropdown-item>
										</b-dropdown>
									</span>
								</b-col>
							</b-row>
						</div>
					</b-col>
				</b-row>
			</template>

		</app-table-input-popup>
        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import StockOpnameResult from '@/models/StockOpnameResult/StockOpnameResult';
import StockOpnameResultList from '@/models/StockOpnameResult/StockOpnameResultList';
import StockOpnameResultFilter from '@/filters/StockOpnameResult/StockOpnameResultFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import StockOpname from '@/models/StockOpname/StockOpname';
import StockOpnameFilter from '@/filters/StockOpname/StockOpnameFilter';
import AppInputFileupload from '@/components/AppInputFileupload';
import Attachment from '@/models/Core/Attachment';
import AttachmentFilter from '@/filters/Core/AttachmentFilter';
import Area from '@/models/Area/Area';
import AreaFilter from '@/filters/Area/AreaFilter';
import StockOpnamePlan from '@/models/StockOpnamePlan/StockOpnamePlan';
import StockOpnamePlanFilter from '@/filters/StockOpnamePlan/StockOpnamePlanFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import StockOpnameResultDetail from '@/models/StockOpnameResult/StockOpnameResultDetail';
import StockOpnameResultDetailFilter from '@/filters/StockOpnameResult/StockOpnameResultDetailFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import StockOpnameDetail from '@/models/StockOpname/StockOpnameDetail';
import StockOpnameDetailFilter from '@/filters/StockOpname/StockOpnameDetailFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import StockOpnameResultDetailInput from '@/views/StockOpnameResult/StockOpnameResultDetailInput';
import StockOpnameResultDetailUpload from '@/views/StockOpnameResult/StockOpnameResultDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputFileupload,
		AppInputTextbox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		StockOpnameResultDetailInput,StockOpnameResultDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			fileUpload: null,
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsStockOpnameResultDetail: [
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"controlCard": { "class" : "th-control-card first-child", "label" : "Control Card", key: 'controlCard', sortable: false}}, 
				{"partNumber": { "class" : "th-part-number", "label" : "Part Number", key: 'partNumber', sortable: false}}, 
				{"partName": { "class" : "th-part-name d-stack-none", "label" : "Part Name", key: 'partName', sortable: false}}, 
				{"qtySystem": { "class" : "th-qty-system text-right", "label" : "Qty System", key: 'qtySystem', sortable: false}}, 
				{"totalPriceQtySystem": { "class" : "th-total-price-qty-system last-child text-right", "label" : "Total Price Qty System", key: 'totalPriceQtySystem', sortable: false}}, 
				{"qtyActual": { "class" : "th-qty-actual d-stack-none text-right", "label" : "Qty Actual", key: 'qtyActual', sortable: false}}, 
				{"totalPriceQtyActual": { "class" : "th-total-price-qty-actual d-stack-none text-right", "label" : "Total Price Qty Actual", key: 'totalPriceQtyActual', sortable: false}}, 
				{"totalDifferenceQty": { "class" : "th-total-difference-qty d-stack-none text-right", "label" : "Total Difference Qty", key: 'totalDifferenceQty', sortable: false}}, 
				{"totalDifferencePrice": { "class" : "th-total-difference-price d-stack-none text-right", "label" : "Total Difference Price", key: 'totalDifferencePrice', sortable: false}}, 
				{"differenctPercentage": { "class" : "th-differenct-percentage d-stack-none text-right", "label" : "Difference Percentage", key: 'differenctPercentage', sortable: false}}, 
				{"scannedDate": { "class" : "th-scanned-date d-stack-none", "label" : "Scanned Date", key: 'scannedDate', sortable: false}}, 
				{"scannedBy": { "class" : "th-scanned-by d-stack-none", "label" : "Scanned By", key: 'scannedBy', sortable: false}}, 
				// {"stockOpnameDetail": { "class" : "th-stock-opname-detail d-stack-none", "label" : "Stock Opname Detail", key: 'stockOpnameDetail', sortable: false}}, 
				{"remarks": { "class" : "th-remarks d-stack-none", "label" : "Remarks", key: 'remarks', sortable: false}}, 
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelStockOpnameResultDetail : {},
			isShowPopupStockOpnameResultDetail : false,
			isShowPopupUploadStockOpnameResultDetail : false,
			filterStockOpnameResult : null,
			currentStockOpnameResultPage : 1,
			stockOpnameResultPageSize: 10,
			sortByStockOpnameResult: '',
			sortDescStockOpnameResult: '',
			filterStockOpnameResultDetail : null,
			currentStockOpnameResultDetailPage : 1,
			stockOpnameResultDetailPageSize: 10,
			sortByStockOpnameResultDetail: '',
			sortDescStockOpnameResultDetail: '',
			sortingByStockOpnameResultDetail: [],
			stockOpnameResultDetails : [],
			stockOpnameResultDetailId : '',
			totalStockOpnameResultDetailRow : 0,
			isShowStockOpnameResultDetailFilter: false,
			isDownloadStockOpnameResultDetail: false,
			controlCards: [],
			userInfos: [],
			stockOpnameDetails: [],
			stockOpnames: [],
			stockOpnames: [],
			isStockOpnameComboLoading: false,
			areas: [],
			areas: [],
			isAreaComboLoading: false,
			stockOpnamePlans: [],
			stockOpnamePlans: [],
			isStockOpnamePlanComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isStockOpnameComboLoading: false,
			isAttachmentComboLoading: false,
			isAreaComboLoading: false,
			isStockOpnamePlanComboLoading: false,
			isStockOpnameResultComboLoading: false,
			isControlCardComboLoading: false,
			isUserInfoComboLoading: false,
			isStockOpnameDetailComboLoading: false,
			stockOpnameResultDetailsPaging: [],
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getStockOpnameResult : async function(id) {
			this.isBusy = true;
			StockOpnameResult.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadStockOpnameResult = true;
			this.filterStockOpnameResult.id = this.modelId;
			StockOpnameResult.downloadDataDetail(this, this.filterStockOpnameResult).then(result => {
				this.isDownloadStockOpnameResult = false;
			}).catch(error => { this.isDownloadStockOpnameResult = false; })
		},
		getStockOpnameResultDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterStockOpnameResultDetail);
			if (this.modelId == null) return;
			filter.stockOpnameResultId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByStockOpnameResultDetail != null) {
				this.sortingByStockOpnameResultDetail[this.sortByStockOpnameResultDetail] = this.sortDescStockOpnameResultDetail;
			}
			let currentPage = (this.currentStockOpnameResultDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalStockOpnameResultDetailRow + 1;
				let page = Math.ceil(totalData/this.stockOpnameResultDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			//currentPage = null;
			//this.stockOpnameResultDetailPageSize = 0;
			// disable paging end
			StockOpnameResultDetail.getList(this, filter, this.sortingByStockOpnameResultDetail, currentPage , this.stockOpnameResultDetailPageSize).then(result => {
				this.currentStockOpnameResultDetailPage = currentPage + 1;
				this.stockOpnameResultDetails = result.data;
				result.data.forEach(item => {
					if(item.totalDifferenceQty==null || item.totalDifferenceQty==undefined|| item.totalDifferenceQty > 0){
						item._rowVariant  = 'danger';
					}
				});
				this.stockOpnameResultDetailsPaging = result;
				this.totalStockOpnameResultDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getStockOpnameResults : async function(input) {
			let filter = new StockOpnameResultFilter();
			if (input != undefined) {
				filter.StoResultNumber = input;
			}
			this.isStockOpnameResultComboLoading = true;
			StockOpnameResult.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnameResults = result.data
				}
				this.isStockOpnameResultComboLoading = false;
			})
			.catch(error => {});
		},
		getStockOpnameResults : async function(input) {
			let filter = new StockOpnameResultFilter();
			if (input != undefined) {
				filter.stoResultNumber = input;
			}
			this.isStockOpnameResultComboLoading = true;
			StockOpnameResult.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnameResults = result.data
				}
				this.isStockOpnameResultComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			this.isUserInfoComboLoading = true;
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
				this.isUserInfoComboLoading = false;
			})
			.catch(error => {});
		},
		getStockOpnameDetails : async function(input) {
			let filter = new StockOpnameDetailFilter();
			if (input != undefined) {
				filter.controlCard = input;
			}
			this.isStockOpnameDetailComboLoading = true;
			StockOpnameDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnameDetails = result.data
				}
				this.isStockOpnameDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getStockOpnames : async function(input) {
			let filter = new StockOpnameFilter();
			if (input != undefined) {
				filter.stockOpnamePlan = input;
			}
			StockOpname.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnames = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedStockOpname(item) {
			if(item == undefined || item == null) {
				this.model.stockOpnameId = null;
				this.model.stockOpname = null;
			} else {
				this.model.stockOpnameId = item.id;
				this.model.stockOpname = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getAreas : async function(input) {
			let filter = new AreaFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Area.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.areas = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedArea(item) {
			if(item == undefined || item == null) {
				this.model.areaId = null;
				this.model.area = null;
			} else {
				this.model.areaId = item.id;
				this.model.area = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getStockOpnamePlans : async function(input) {
			let filter = new StockOpnamePlanFilter();
			if (input != undefined) {
				filter.name = input;
			}
			StockOpnamePlan.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnamePlans = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedStockOpnamePlan(item) {
			if(item == undefined || item == null) {
				this.model.stockOpnamePlanId = null;
				this.model.stockOpnamePlan = null;
			} else {
				this.model.stockOpnamePlanId = item.id;
				this.model.stockOpnamePlan = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.stockOpnameResultInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					StockOpnameResult.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'stockopnameresultindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					StockOpnameResult.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'stockopnameresultindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			if (this.fileUpload != null) {
				let data = new FormData();
				data.append('file', this.fileUpload);
				let _this = this;
				promises.push(this.$http.post('attachment/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								model.fileUploadId = response.data.id;
								model.fileUpload = response.data;
								_this.fileUpload = null;
							}
						}
						return true;
					})
					.catch(error => {
						this.$store.dispatch('addErrorMessageGlobal', error);
						throw error;
					}));
			}

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					StockOpnameResult.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getStockOpnameResult(id);
					});
				}
			});
		},
		onHidden() {
			this.getStockOpnameResults();
		},
		addRowDataStockOpnameResultDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.stockOpnameResultId =  this.modelId;
					StockOpnameResultDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getStockOpnameResultDetails(true);
						this.isShowPopupStockOpnameResultDetail = false;
					})
				} else {
					model.stockOpnameResultId =  this.modelId;
					StockOpnameResultDetail.createDataDetail(this, model)
					.then(result => {
						this.getStockOpnameResultDetails(true);
						this.isShowPopupStockOpnameResultDetail = false;
					})
				}
			}
		},
		async editRowDataStockOpnameResultDetail(id) {
			this.stockOpnameResultDetailId = id;
			this.isShowPopupStockOpnameResultDetail = true; 
		},
		async deleteRowDataStockOpnameResultDetail(id) {
			StockOpnameResultDetail.deleteData(this, id).then(result => { this.getStockOpnameResultDetails(); });
		},
		async resetDataStockOpnameResultDetail() {
			this.stockOpnameResultDetailId = "";
			this.isShowPopupStockOpnameResultDetail = true;
		},
		async addDataStockOpnameResultDetail() {
			StockOpnameResultDetail.createData(this, { stockOpnameResultId: this.modelId })
			.then(result => {
				this.getStockOpnameResultDetails(true);
			})
		},
		async addFromClipboardStockOpnameResultDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, stockOpnameResultId: this.modelId });
				});
				StockOpnameResultDetail.addFromClipboard(this, controlCards).then(result => { this.getStockOpnameResultDetails() });
			});
		},
		async replaceFromClipboardStockOpnameResultDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, stockOpnameResultId: this.modelId });
				});
				StockOpnameResultDetail.replaceFromClipboard(this, controlCards).then(result => { this.getStockOpnameResultDetails() });
			});   
		},
		showPopupUploadStockOpnameResultDetail() {
			if(this.stockOpnameResultDetails != null && this.stockOpnameResultDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap StockOpnameResultDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadStockOpnameResultDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadStockOpnameResultDetail = true;
			}
		},
		uploadDataStockOpnameResultDetail(modalEvent, newDatas) {
			this.isShowPopupUploadStockOpnameResultDetail = false; 
		},
		downloadStockOpnameResultDetail(modalEvent) {
			this.isDownloadStockOpnameResultDetail = true;
			this.filterStockOpnameResultDetail.stockOpnameResultId = this.modelId;
			StockOpnameResultDetail.downloadDataDetail(this, this.filterStockOpnameResultDetail).then(result => {
				this.isDownloadStockOpnameResultDetail = false;
			}).catch(error => { this.isDownloadStockOpnameResultDetail = false; })
		},
		saveInputStockOpnameResultDetail(item) {
			if (this.stockOpnameResults != null && this.stockOpnameResults != undefined  && this.stockOpnameResults.length > 0) {
				item.stockOpnameResult = this.stockOpnameResults.find(q => q.id == item.stockOpnameResultId);
			}
			if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}
			if (this.userInfos != null && this.userInfos != undefined  && this.userInfos.length > 0) {
				item.scannedBy = this.userInfos.find(q => q.id == item.scannedByUserName);
			}
			if (this.stockOpnameDetails != null && this.stockOpnameDetails != undefined  && this.stockOpnameDetails.length > 0) {
				item.stockOpnameDetail = this.stockOpnameDetails.find(q => q.id == item.stockOpnameDetailId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					StockOpnameResultDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadStockOpnameResultDetail = false; 
			this.isShowPopupStockOpnameResultDetail = false; 
			if (modalType == 'StockOpnameResultDetail') {
				this.getStockOpnameResultDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowStockOpnameResultDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterStockOpnameResult = new StockOpnameResultFilter();
		this.filterStockOpnameResultDetail = new StockOpnameResultDetailFilter();
		//this.getStockOpnameResults();
		this.getControlCards();
		this.getUserInfos();
		//this.getStockOpnameDetails();
		//this.getStockOpnames();
		//this.getAreas();
		//this.getStockOpnamePlans();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getStockOpnameResult(id);
			} else {
				this.modelId = id;
				this.getStockOpnameResult(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByStockOpnameResultDetail : {
			handler: function() {
				this.getStockOpnameResultDetails();
			}
		},
		sortDescStockOpnameResultDetail: {
			handler: function() {
				this.getStockOpnameResultDetails();
			}
		},
		currentStockOpnameResultDetailPage: {
			handler: function() {
				this.getStockOpnameResultDetails();
			}
		},
		stockOpnameResultDetailPageSize : {
			handler: function() {
				this.getStockOpnameResultDetails();
			}
		},
		filterStockOpnameResultDetail: {
			handler: function() {
				this.getStockOpnameResultDetails();
			},
			deep: true,
		},
	},
}
</script>
<style lang="scss" scoped>
::v-deep .custom-row-style {
	border-color: #dee2e6;
	.table-danger {
		background-color: #f2dede;
	}
	.table-danger.tr:nth-of-type(odd) {
		background-color: #f2dede;
	}
}
</style>